import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import exmamhistory from '../examhistory';
//import jwt_decode from 'jwt-decode';

//var userid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).id : 0 ;

const styles = {
    iconRed: { 
           paddingRight: '0.5em' ,
           color: 'orange'
        },
    icon: { 
        paddingRight: '0.5em' ,
        },
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const LinkToHistory = ({ classes, record}) => {
    //console.log(record)
    return <Button
        size="small"
        color= "primary" 
        component={Link}
        to={{
            pathname: '/donhistory',
            search: stringify({
                page: 1,
                perPage: 25,
                sort: 'id',
                order: 'DESC',
                filter: JSON.stringify({ ssn : record.ssn}),
            }),
        }}
        className={classes.link}
    >
        <exmamhistory.icon />History
    </Button>
};

export default withStyles(styles)(LinkToHistory);